import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert, Container } from "react-bootstrap";
import { useAuth } from "../Contexts/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { useWebinarContext } from "../../softwareWebinar/WebinarContext";
import { SignupTypes } from "./AccountTypes";
import { firestore } from "../firebase";

export default function Signup({ createdAccount }) {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useWebinarContext().navigate_WebinarWrapper;
  const currentPathname = useLocation().pathname;

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    try {
      setError("");
      setLoading(true);
      const signupData = await signup(emailRef.current.value, passwordRef.current.value);

      createdAccount && createdAccount(); //Triggers going to next Part when used in "/webinar"
      if (currentPathname !== "/webinar") navigate("/"); //Navigate to "/" only when not in webinar in Webinar
    } catch {
      setError("Failed to create an account");
    }

    setLoading(false);
  }

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-100" style={{ maxWidth: "400px" }}>
        <Card style={{ padding: 30 }}>
          <Card.Body>
            <h2 className="text-center mb-4">Sign Up</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group style={{ marginBottom: 15 }} id="email">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" ref={emailRef} required />
              </Form.Group>
              <Form.Group style={{ marginBottom: 15 }} id="password">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" ref={passwordRef} required />
              </Form.Group>
              <Form.Group style={{ marginBottom: 30 }} id="password-confirm">
                <Form.Label>Password Confirmation</Form.Label>
                <Form.Control type="password" ref={passwordConfirmRef} required />
              </Form.Group>
              <Button disabled={loading} className="w-100" style={{ color: "white" }} type="submit">
                Sign Up
              </Button>
            </Form>
          </Card.Body>
        </Card>
        {currentPathname !== "/webinar" && (
          <div className="w-100 text-center mt-2">
            Already have an account?{" "}
            <Link className="primary-font-color" to="/login">
              Log In
            </Link>
          </div>
        )}
      </div>
    </Container>
  );
}
